import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './FieldCopy.module.css';

const FieldCopy = props => {
  const { className, rootClassName, children } = props;
  const classes = classNames(rootClassName || css.root, className);

  return <p className={classes}>{children}</p>;
};

FieldCopy.defaultProps = {
  className: null,
  rootClassName: null,
};

FieldCopy.propTypes = {
  className: string,
  rootClassName: string,
};

export default FieldCopy;
